import { useState, useEffect } from 'react';
import { PayConfirmSvg } from '../../styles/IconStyle';
import FooterAction from '../FooterAction';
import ButtonFrame from '../ButtonFrame';
import { useNavigate, useOutletContext } from 'react-router-dom';
import { UrlType } from '../../constant/objects_types';

const WithdrawalComplete = ({ visible, amount }:{
    visible: boolean,
    amount:string
}) => {

    const [firstShow, setFirstShow] = useState<boolean>(false);
    const navigate = useNavigate();
    const { setOpenWithdrawComplete }:{setOpenWithdrawComplete:Function} = useOutletContext();

    useEffect(() => {
        if (firstShow) return;
        if (!visible) return;
        setFirstShow(true);
    }, [visible, firstShow]);

    return (
        <>
            {firstShow && (
                <>
                <div className={`modalParentContainer${visible ? " animate__animated animate__slideInRight" :  " animate__animated animate__slideOutRight"}`} style={{backgroundColor:"#0D0404"}}>
                    <div className="modalContainer" style={{}}>
                        <div style={{margin:"0px 20px", width:'100%', height:'100%', position:'relative'}}>
                            <div style={{height:"calc(100% - 90px)", display:'flex', flexDirection:'column', alignItems:'center', justifyContent:'center'}}>
                                <PayConfirmSvg />
                                <div style={{marginTop:"25px"}}>
                                    <div className='sectionTitle' style={{textAlign:'center', fontSize:"14px"}}>Awesome!</div>
                                    <div className="locationRegion" style={{textAlign:'center', marginTop:"5px"}}>Your <strong>{amount}</strong> withdraw request is successful and currently being processed. </div>
                                </div>
                            </div>
                            <FooterAction contStyle={{border:'none', padding:"0", bottom:"90px"}}>
                                <ButtonFrame title="Return to Profile" contStyle={{marginTop: "12px", backgroundColor:'#DB012E', border:"none"}} onPress={() => {
                                    navigate(`${UrlType.PROFILE_USER}me`);
                                    setOpenWithdrawComplete(false);
                                }} />
                            </FooterAction>
                        </div>
                    </div>
                </div>
            </>
            )}
            
        </>
    )
}

export default WithdrawalComplete;